import React, { useMemo } from 'react'
import { Typography } from 'antd'
import { useSelector } from 'react-redux'

import { RequestQuoteVehicle } from 'src/types'

import { ApplicationState } from 'src/store'
import { Button, Card, Modal, List } from 'src/components/Ant'

import ListItemVehicleHistory from './list-item-vehicle'

type Props = {
  toggle(): void
  visible: boolean
}

function ModalHistory({ toggle, visible }: Props) {
  const {
    vehicles: {
      error,
      loading,
      originalFullRequestVehiclesHistory: fullRequest
    }
  } = useSelector((state: ApplicationState) => ({
    vehicles: state.vehicles
  }))

  const vehicleQuotes = useMemo(() => {
    const offers: RequestQuoteVehicle[] = []
    fullRequest?.request_quote_vehicle_routes?.forEach(routes => {
      routes.request_quote_vehicles.forEach(quote => {
        offers.push({ ...quote })
      })
    })
    return offers
  }, [fullRequest])
  return (
    <Modal
      closable
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            toggle()
          }}
          size="default"
          title="common.actions.cancel"
          type="default"
        />
      ]}
      forceRender
      maskClosable
      onCancel={() => {
        toggle()
      }}
      title="web.services.vehicle.history-title"
      visible={visible}
      width={820}
    >
      {error ? (
        <Typography.Text>{error}</Typography.Text>
      ) : (
        <Card loading={loading}>
          <List
            dataSource={vehicleQuotes}
            itemLayout="vertical"
            renderItem={item => <ListItemVehicleHistory item={item} />}
          />
        </Card>
      )}
    </Modal>
  )
}

export default ModalHistory
